export default {
    state: {
        isClientScoped: false,
        authorizedClients: [],
        selectedClientId: null,
    },

    getters: {
        authorizedClientOptions: (state) => state.authorizedClients,
    },

    mutations: {
        SET_CLIENT_SCOPE_CONTEXT(state, payload = {}) {
            state.isClientScoped = Boolean(payload.isClientScoped);
            state.authorizedClients = Array.isArray(payload.authorizedClients) ? payload.authorizedClients : [];
            state.selectedClientId = payload.selectedClientId ?? null;
        },
    },
}
